import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    InputLabel,
    InputBase,
    FormControlLabel,
    Radio,
    RadioGroup,
    Button,
    FormControl,
    FormHelperText,
    DialogTitle,
} from '@material-ui/core';
import { messageFormat } from 'mdoc/utils';
import schema from 'async-validator';
import Dialog from 'mdoc/utils/myDialog';
import Toast from 'mdoc/utils/toast';
import { dictionary, getActiveDirectoryModification, getActiveDirectoryAdd, getActiveDirectoryTest } from 'mdoc/admin/axios'

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    bootstrapFormLabel: {
        lineHeight: '30px'
    },
    bootstrapFormRadioLabel: {
        lineHeight: '30px'
    },
    Radio: {
        padding: '0px 10px'
    },
    buttonlogin: {
        marginLeft: '380px',
        marginTop: '40px',
    },
    buttoncancel: {
        marginLeft: '30px',
        marginTop: '40px',
    },
    required: {
        color: '#F72D2D'
    },
    title: {
        marginLeft: '-20px'
    },
    button: {
        padding: '2px'
    }
});

class ActiveDirectoryAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                userId: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
                serverName: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
                url: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
                password: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
                domainNode: {
                    value: '',
                    error: false,
                    errorMsg: ''
                },
                validFlg: {
                    value: 'VALID',
                    error: false,
                    errorMsg: ''
                },
            },
            dictWord: {
                connection_test: '',
                registration: '',
                cancel: '',
                password: '',
                sever_name: '',
                url: '',
                user_id: '',
                valid_flg: '',
                valid: '',
                invalid: '',
                last_acquisition_date: '',
                confirmation: '',
                msg_error_not_null_with_item: '',
                msg_error_over_length_with_item: '',
                msg_warning_active_directory_setting: '',
                msg_connection_test_succeeded: '',
                domain_node:'',
                msg_error_value_invalid:'',
                yes:''
            },
            disabledAll: false,
            dialogOpen: false
        };

    }
    componentWillMount() {
        this.start(this.state);
    }

    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
        if (this.props.match.params.id !== undefined) {
            let id = this.props.match.params.id;
            this.setState({
                loading: true,
            });
            getActiveDirectoryModification({
                id: id
            }).then(res => {
                const detail = res.results;
                let formData = this.state.formData;
                let serverName = Object.assign(this.state['formData']['serverName'], { value: detail['serverName'], disabled: true });
                formData['serverName'] = serverName;
                let url = Object.assign(this.state['formData']['url'], { value: detail['serverBaseUrl'], disabled: true });
                formData['url'] = url;
                let serverUserId = Object.assign(this.state['formData']['userId'], { value: detail['serverUserId'], disabled: true });
                formData['userId'] = serverUserId;
                let password = Object.assign(this.state['formData']['password'], { value: detail['encryptedPassword'], disabled: true });
                formData['password'] = password;
                let domainNode = Object.assign(this.state['formData']['domainNode'], { value: detail['domainNode'], disabled: true });
                formData['domainNode'] = domainNode;
                let validFlg = Object.assign(this.state['formData']['validFlg'], { value: detail['validFlg'], disabled: true });
                formData['validFlg'] = validFlg;
                this.setState({
                    loading: false,
                    formData: formData
                });
            })
        }
    }

    dialogHandleOK = () => {
        const confirmData = this.state.formData;
        let type = 'post';
        if (this.props.match.params.id !== undefined) {
            type = 'put';
        }
        getActiveDirectoryAdd({
            id: this.props.match.params.id !== undefined ? this.props.match.params.id : '',
            serverName: confirmData['serverName']['value'],
            serverBaseUrl: confirmData['url']['value'],
            serverUserId: confirmData['userId']['value'],
            encryptedPassword: confirmData['password']['value'],
            domainNode:confirmData['domainNode']['value'],
            validFlg: confirmData['validFlg']['value'],
        }, type).then((res) => {
            this.props.history.push('/admin/management/activeDirectory');
        }).catch(function (error) {
            Toast.error(error);
        })
    }

    handleChange = (filed) => event => {
        let formData = this.state.formData;
        formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        this.setState({
            formData: formData
        });
    };
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }

    handleSubmit = () => {
        let descriptor = {
            serverName: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.sever_name) },
                {
                    max: 250,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.sever_name)
                }
            ],
            url: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.url) },
                {
                    max: 256,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.url)
                },
            ],
            userId: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.user_id) },
                {
                    max: 50,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.user_id)
                },
            ],
            password: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.password) },
                {
                    max: 256,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.password)
                },
            ],
            domainNode: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.domain_node) },
                {
                    max: 64,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.domain_node)
                },
            ]
        }
        const validator = new schema(descriptor);
        let resourceData = {};
        const formData = this.state.formData;
        for (let index in formData) {
            let item = formData[index];
            let value = item.value;
            resourceData[index] = value;
        }
        
        validator.validate(resourceData, {
            firstFields: true
        }, (errors, fields) => {
            let formData = this.state.formData;
            let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
            let emojierr = [];
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
                let value = formData[index].value;
                if (value && typeof value !== 'object' && value.length > 0) {
                    if (value.search(emojiReg) >= 0) {
                        emojierr.push({ 'message': this.state.dictWord.msg_error_value_invalid, 'field': index });
                    }
                }
            }
            if (errors || emojierr.length > 0) {
                if (errors) {
                    errors.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                if (emojierr.length > 0) {
                    emojierr.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    dialogOpen: true,
                    formData: formData
                });
            }
        })

    }

    DirectoryTest = () => {
        const confirmData = this.state.formData;
        getActiveDirectoryTest({
            serverBaseUrl: confirmData['url']['value'],
            serverUserId: confirmData['userId']['value'],
            encryptedPassword: confirmData['password']['value'],
        }).then((res) => {
            let testResults = res.results;
            if (!testResults.error) {
                Toast.success(this.state.dictWord.msg_connection_test_succeeded);
            }
        }).catch(function (error) {
            Toast.error(error);
        })
    }

    render() {
        const { classes } = this.props;
        const { formData, dictWord } = this.state;
        return (
            <div className="mainDom" style={{ minWidth: '700px' }}>
                <div className={classes.appBarSpacer} />
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={12}>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.DirectoryTest}>
                            {dictWord.connection_test}
                        </Button>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.handleSubmit}>
                            {dictWord.registration}
                        </Button>
                        <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/management/activeDirectory'}>
                            {dictWord.cancel}
                        </Button>

                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="serverName">
                            {dictWord.sever_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth error={this.state.formData.serverName.error}>
                            <InputBase
                                id="serverName"
                                value={this.state.formData.serverName.value}
                                fullWidth
                                onChange={this.handleChange('serverName')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={formData.serverName.error}

                            />
                            {formData.serverName.error ? <FormHelperText id="serverName-error-text">{formData.serverName.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="url">
                            {dictWord.url}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth error={this.state.formData.url.error}>
                            <InputBase
                                id="url"
                                value={this.state.formData.url.value}
                                fullWidth
                                onChange={this.handleChange('url')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.url.error}
                            />
                            {this.state.formData.url.error ? <FormHelperText id="url-error-text">{this.state.formData.url.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userId">
                            {dictWord.user_id}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth error={this.state.formData.userId.error}>
                            <InputBase
                                id="userId"
                                value={this.state.formData.userId.value}
                                fullWidth
                                onChange={this.handleChange('userId')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.userId.error}
                            />
                            {this.state.formData.userId.error ? <FormHelperText id="userId-error-text">{this.state.formData.userId.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="password">
                            {dictWord.password}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth error={this.state.formData.password.error}>
                            <InputBase
                                id="password"
                                type="password"
                                value={this.state.formData.password.value}
                                fullWidth
                                onChange={this.handleChange('password')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.password.error}
                            />
                            {this.state.formData.password.error ? <FormHelperText id="password-error-text">{this.state.formData.password.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="domainNode">
                            {dictWord.domain_node}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth error={this.state.formData.domainNode.error}>
                            <InputBase
                                id="domainNode"
                                type="domainNode"
                                value={this.state.formData.domainNode.value}
                                fullWidth
                                onChange={this.handleChange('domainNode')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.domainNode.error}
                            />
                            {this.state.formData.domainNode.error ? <FormHelperText id="domainNode-error-text">{this.state.formData.domainNode.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="validFlg">
                            {dictWord.valid_flg}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.validFlg.value}
                            onChange={this.handleChange('validFlg')}
                            row
                        >
                            <FormControlLabel
                                value="VALID"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="INVALID"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_warning_active_directory_setting']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        );
    }
}

ActiveDirectoryAdd.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ActiveDirectoryAdd);